import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { pickCategoryFields } from '../../util/fieldHelpers';
import { getWedlyListingDetailRows } from '../../util/wedlyListingConfigHelpers';
import { Heading } from '../../components';

import sectionCss from '../../components/CustomExtendedDataSection/CustomExtendedDataSection.module.css';
import listingCss from './ListingPage.module.css';

/**
 * Displays Wedly category-specific listing fields on the listing page.
 *
 * @param {Object} props
 * @param {Object} props.publicData
 * @param {Object} props.categoryConfiguration
 * @param {Object} props.intl
 * @param {'details'|'specCard'} [props.variant] layout variant
 */
const WedlyCategoryListingDetails = props => {
  const { publicData, categoryConfiguration, intl, variant = 'details' } = props;

  const { key: categoryPrefix, categories: listingCategories } = categoryConfiguration || {};
  const categoryIds = Object.values(
    pickCategoryFields(publicData, categoryPrefix, 1, listingCategories)
  );
  const rows = getWedlyListingDetailRows(publicData, categoryIds, listingCategories, intl);

  if (rows.length === 0) {
    return null;
  }

  if (variant === 'specCard') {
    return (
      <div className={listingCss.specCard}>
        {rows.map(row => (
          <div key={row.key} className={listingCss.specRow}>
            <span className={listingCss.specLabel}>{row.label}</span>
            <span className={listingCss.specValue}>{row.value}</span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <section className={sectionCss.sectionDetails}>
      <Heading as="h2" rootClassName={sectionCss.sectionHeading}>
        <FormattedMessage id="ListingPage.detailsTitle" />
      </Heading>
      <ul className={sectionCss.details}>
        {rows.map(row => (
          <li key={row.key} className={sectionCss.detailsRow}>
            <span className={sectionCss.detailLabel}>{row.label}</span>
            <span>{row.value}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default WedlyCategoryListingDetails;
